/**
 * 학생 전체 통계 카드 컴포넌트
 * 학생의 전반적인 성적을 한 눈에 보여주는 카드
 */

import React from 'react';
import { Card, Row, Col, Statistic } from 'antd';
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  ClockCircleOutlined,
  TrophyOutlined,
  ReloadOutlined,
} from '@ant-design/icons';
import { StudentOverallStats } from '../../types/stats';

interface StudentOverallCardProps {
  stats: StudentOverallStats;
  loading?: boolean;
}

export const StudentOverallCard: React.FC<StudentOverallCardProps> = ({
  stats,
  loading = false,
}) => {
  return (
    <Card title={`${stats.student_name}님 전체 통계`} loading={loading}>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={6}>
          <Statistic
            title="정답률"
            value={stats.overall_accuracy}
            precision={1}
            suffix="%"
            valueStyle={{ color: '#3f8600' }}
            prefix={<CheckCircleOutlined />}
          />
        </Col>

        <Col xs={24} sm={12} md={6}>
          <Statistic
            title="정답 문제"
            value={stats.correct_problems}
            suffix={`/ ${stats.total_problems_submitted}`}
            valueStyle={{ color: '#52c41a' }}
            prefix={<CheckCircleOutlined />}
          />
        </Col>

        <Col xs={24} sm={12} md={6}>
          <Statistic
            title="오답 문제"
            value={stats.wrong_problems}
            valueStyle={{ color: '#cf1322' }}
            prefix={<CloseCircleOutlined />}
          />
        </Col>

        <Col xs={24} sm={12} md={6}>
          <Statistic
            title="채점 대기"
            value={stats.pending_problems}
            valueStyle={{ color: '#faad14' }}
            prefix={<ClockCircleOutlined />}
          />
        </Col>

        <Col xs={24} sm={12} md={6}>
          <Statistic
            title="평균 시도 횟수"
            value={stats.average_attempts}
            precision={2}
            prefix={<ReloadOutlined />}
          />
        </Col>

        <Col xs={24} sm={12} md={6}>
          <Statistic
            title="총 획득 점수"
            value={stats.total_score}
            valueStyle={{ color: '#1890ff' }}
            prefix={<TrophyOutlined />}
          />
        </Col>
      </Row>
    </Card>
  );
};
